module.exports = __webpack_public_path__ + "img/nodejs-icon.5c376133.svg";